export class Tanium {
  constructor(
    private readonly url: string,
    private readonly accessToken: string,
    private readonly trustedCaCertificate: string | null,
    private readonly maxConcurrentRetrievals: number | null,
    private readonly requestRate: number | null
  ) {}

  getUrl() {
    return this.url;
  }

  getAccessToken() {
    return this.accessToken;
  }

  getTrustedCaCertificate() {
    return this.trustedCaCertificate;
  }

  getMaxConcurrentRetrievals() {
    return this.maxConcurrentRetrievals;
  }

  getRequestRate() {
    return this.requestRate;
  }
}
